import React, {useMemo} from 'react';
import {observer} from 'mobx-react-lite';
import {Flex, Input, Separator} from '@priority-software/priority-style-react';
import texts from '../../texts';
import FormsSelect from '../FormsSelect';
import styles from '../styles.module.scss';
import {chartConfigInfo} from '../../consts';
import FormInputItem from './FormInputItem';
import {CheckBoxItem} from '../CheckBoxItem';
import {reportGeneratorsStore} from '../../stores/ReportGeneratorsStore';
import {IChartConfig} from '../../types';

const FormInputs = observer(() => {
    const {currentReport, forms, chartInfo, onSaveChartInfo} = reportGeneratorsStore?.currentScreen;
    const {
        nodeId,
        columns,
        isNew,
        setNodeId,
        setReportTitle,
        toggleIsActive,
        isActive,
        isGeneral,
        toggleIsGeneral
    } = currentReport;
    const formTitle = useMemo(() => forms.get(nodeId)?.Title, [nodeId]);

    const formItems = [
        {
            key: chartConfigInfo.baseForm,
            inputComponent: (
                <>
                    {isNew && columns?.length === 0 ? (
                        <FormsSelect value={nodeId} onSelect={setNodeId} />
                    ) : (
                        <Input disabled size="large" value={formTitle} />
                    )}
                </>
            )
        },
        {
            key: chartConfigInfo.chartName,
            inputComponent: (
                <Input
                    state={!chartInfo.chartName ? 'error' : null}
                    value={chartInfo.chartName}
                    onChange={e => {
                        setReportTitle(e.target.value);
                        onSaveChartInfo(
                            chartConfigInfo.chartName as keyof IChartConfig,
                            e.target.value
                        );
                    }}
                    placeholder={texts.enterChartName}
                    size="large"
                    maxLength={32}
                    required
                    autoFocus
                />
            )
        },
        {
            key: chartConfigInfo.subTitle,
            inputComponent: (
                <Input
                    value={chartInfo.subTitle}
                    onChange={e => {
                        onSaveChartInfo(
                            chartConfigInfo.subTitle as keyof IChartConfig,
                            e.target.value
                        );
                        currentReport.updateDirty();
                    }}
                    placeholder={texts.enterSubTitle}
                    size="large"
                    maxLength={32}
                />
            )
        }
    ];

    return (
        <Flex componentClasses={styles.marginH}>
            <Flex direction="row" justifyContent="flex-start" alignItems="flex-start">
                {formItems.map((item, idx) => (
                    <div
                        style={{width: '303px', padding: idx !== 0 ? '0 15px' : '0'}}
                        key={item.key}
                    >
                        <FormInputItem item={item} />
                    </div>
                ))}
            </Flex>
            <Flex direction="row" style={{width: '151px'}} justifyContent="flex-end">
                <Separator align="horizontal" height={60} />
                <div style={{padding: '15px'}}>
                    <CheckBoxItem
                        title={texts.active}
                        isChecked={isActive}
                        helpText={texts.activeHelp}
                        onClick={() => {
                            toggleIsActive();
                            onSaveChartInfo(chartConfigInfo.active as keyof IChartConfig, isActive);
                        }}
                    />
                    <CheckBoxItem
                        title={texts.shared}
                        isChecked={isGeneral}
                        helpText={texts.sharedHelp}
                        onClick={() => {
                            toggleIsGeneral();
                            onSaveChartInfo(chartConfigInfo.share as keyof IChartConfig, isGeneral);
                        }}
                    />
                </div>
            </Flex>
        </Flex>
    );
});

export default FormInputs;
